import * as React from "react";

export const ProfileIcon = ({opacity,isActive, ...props }) => {
  return (
    <svg width={13} height={14} viewBox="0 0 13 14" fill="none" {...props}>
      <g
        // opacity={0.3}
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={opacity}
      >
        <path d="M11.667 13v-1.333A2.667 2.667 0 009 9H3.667A2.667 2.667 0 001 11.667V13M6.333 6.333a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333z" />
      </g>
    </svg>
  );
};
